/* eslint-disable react/jsx-props-no-spreading */
import { IconCheck, IconChecks } from "@tabler/icons-react";

import Avatar, { AvatarProps, AvatarSize } from "../Avatar/Avatar";
import UploadCard from "../FileUpload/UploadCard";

export enum MessageState {
  default = "default",
  sent = "sent",
  read = "read",
}

interface MessageProps {
  message: string;
  avatar: AvatarProps;
  isSender: boolean;
  state?: MessageState
  sentAt?: string;
  attachments?: (File | string)[];
}

const Message = ({
  message, avatar, state = MessageState.default, sentAt, isSender, attachments,
}: MessageProps) => {
  const name = isSender ? "Vous" : avatar.name;
  return (
    <div className={`w-[300px] md:w-[600px] lg:w-[900px]
      ${isSender ? "pl-[48px]" : "pr-[48px]"}
      ${isSender ? "md:pl-[96px]" : "md:pr-[96px]"}
      ${isSender ? "lg:pl-[192px]" : "lg:pr-[192px]"}`}
    >
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Avatar {...avatar} name={name} size={AvatarSize.xs} />
            <span className="typography-medium-base text-text-base">{name}</span>
          </div>
          {sentAt && <span className="typography-small-base text-text-subtle">{sentAt}</span>}
        </div>
        <div className="flex flex-col gap-2 pl-6">
          <div className={`flex flex-col rounded-md shadow-sm gap-1 p-3 typography-small-base
          ${isSender ? "bg-bg-information text-text-on-color" : "bg-bg-subtle text-text-base"}`}
          >
            <span>{message}</span>
            {isSender && state !== MessageState.default && (
              <div className="flex items-center justify-end gap-1">
                <span>{state === MessageState.read ? "Vu" : "Envoyé"}</span>
                {state === MessageState.read ? <IconChecks /> : <IconCheck />}
              </div>
            )}
          </div>
          {attachments?.map((file) => (typeof file === "string"
            ? <img className="w-fill h-[276px]" src={file} alt={file} />
            : <UploadCard className="w-fill" file={file} />))}
        </div>
      </div>
    </div>
  );
};

export default Message;
